'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('./utils'),
    getPubsubRouting = _require.getPubsubRouting;

var _require2 = require('../../../utils'),
    withTimeoutOption = _require2.withTimeoutOption;

module.exports = function (_ref) {
  var ipns = _ref.ipns,
      constructorOptions = _ref.options;

  /**
   * Query the state of IPNS pubsub.
   *
   * @returns {Promise<boolean>}
   */
  return withTimeoutOption( /*#__PURE__*/function () {
    var _state = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              return _context.abrupt("return", {
                enabled: Boolean(getPubsubRouting(ipns, constructorOptions))
              });

            case 4:
              _context.prev = 4;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 4]]);
    }));

    function state(_x) {
      return _state.apply(this, arguments);
    }

    return state;
  }());
};